import {
  Badge,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Link,
  Menu,
  MenuItem,
  Modal,
  Radio,
  Typography,
} from "@mui/material";
import React from "react";
import { useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import { useRouter } from "next/router";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { getCookie } from "../utils/cookie";

import {
  InputLabel,
  Select,
  FormControl,
  FormHelperText,
  LinearProgress,
} from "@mui/material";
import { useEffect } from "react";
import MembershipModal from "../Modal/MembershipModal";
import FindDivineModal from "../Modal/FindDivineModal";
import StudyChapterModal from "../Modal/StudyChapterModal";
import { useSelector } from "react-redux";
import FloatingCartButton from "../FloatingCartButton/FloatingCartButton";

const Navbar = () => {
  const [user, setUser] = useState({ user_type: "is_astrologer" });
  const [error, setError] = useState({});
  const [newOpen, setNewOpen] = useState(false);
  const [calendermodalopen, setcalendermodalopen] = useState(false);

  const [deitiesmodalopen, setdeitiesmodalopen] = useState(false);

  const [newwOpen, setNewwOpen] = useState(false); //-------diviner state----------//

  const [membershipOpen, setMembershipOpen] = useState(false);

  const [studychapOpen, setStudychapOpen] = useState(false); //-------------study---chap--modal-----//
  const [cartCount, setCartCount] = useState(0);
  const [mounted, setMounted] = useState(false);

  // const cartCount = useSelector((state) => state.TarrotCard.cartCount);

  const handleNewOpen = () => setNewOpen(true);
  const handleNewClose = () => setNewOpen(false);
  const handlecalendermodalopen = () => setcalendermodalopen(false);

  

  const handleNewwOpen = () => {
    setNewwOpen(true);
  };

  const memberfunc = () => {
    setMembershipOpen(true);
  };

  const studychapfunc = () => {
    setStudychapOpen(true);
  };
  const [anchorEl5, setAnchorEl5] = useState(null);

  const handleClick5 = () => {
    setAnchorEl5((current) => !current);
  };
  const handleClose5 = () => setAnchorEl5(false);

  const router = useRouter();
  const location = useRouter();
  const { pathname } = location;

  const hideCartOnThisRoute =
  router.pathname === "/shop/cart" ||
  router.pathname === "/payment-success-page" ||
  router.pathname === "/login" ||
  router.pathname === "/subscription";

  const calenderredirect = () => {
    router.push("/calendar-of-events");
  };
  const calenderredirectNewly = () => {
    router.push("/calendar-of-events-newly");
  };
  const deitiesredirect = (e) => {
    e.preventDefault();
    router.push("/deities");
  };

  const [showOtherBlocks, setShowOtherBlocks] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowOtherBlocks(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => setMounted(true), []);
  useEffect(() => {
    try {
      const raw = localStorage.getItem("cartCount");
      if (raw !== null) setCartCount(Number(raw) || 0);
    } catch {}
  }, []);

  useEffect(() => {
    const controller = new AbortController();

    if (mounted) {
      try {
        const cached = localStorage.getItem("cartCount");
        const n = Number(cached);
        if (!Number.isNaN(n)) setCartCount(n);
      } catch {}
    }

    (async () => {
      try {
        const obj = {
          searchcondition: { user_id: getCookie("guest_id") },
          sort: { type: "asc", field: "priority" },
        };

        const res = await fetch(
          `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}cart_management/cart-user-list`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(obj),
            signal: controller.signal,
          }
        );
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const rep = await res.json();

        if (rep?.status === "success" && Array.isArray(rep?.results?.res)) {
          const count = rep.results.res.reduce(
            (acc, item) => acc + (Number(item?.quantity) || 0),
            0
          );
          setCartCount(count);
          try {
            localStorage.setItem("cartCount", String(count));
          } catch {}
        }
      } catch (e) {
        console.error("Cart fetch failed:", e);
      } finally {
        try {
          localStorage.removeItem("cartUpdated");
        } catch {}
        document.cookie =
          "cartUpdated=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      }
    })();

    return () => controller.abort();
  }, [mounted, pathname]);

  useEffect(() => {
    async function fetchData() {
      let obj = {
        searchcondition: {
          user_id: getCookie("guest_id"),
        },
        sort: {
          type: "asc",
          field: "priority",
        },
      };

      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...obj }),
      };

      let rep = await fetch(
        `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}cart_management/cart-user-list`,
        requestOptions
      );
      rep = await rep.json();
      console.log("rep============>", rep);

      if (rep.status === "success") {
        console.log("rep.results.res------->", rep.results.res);
        const count = rep.results.res?.reduce(
          (accumulator, currentValue) => accumulator + currentValue.quantity,
          0
        );
        console.log("count------->", count);
        setCartCount(parseInt(count));
      }
    }
    const handleCartUpdate = async () => {
      await fetchData();
      localStorage.removeItem("cartUpdated");
      document.cookie =
        "cartUpdated=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    };

    window.addEventListener("cartUpdated", handleCartUpdate);

    window.addEventListener("storage", (e) => {
      if (e.key === "cartUpdated") {
        handleCartUpdate();
      }
    });

    return () => {
      window.removeEventListener("cartUpdated", handleCartUpdate);
      window.removeEventListener("storage", handleCartUpdate);
    };
  }, []);

  return (
    <>
      {/* Preload fonts in the head of the component */}

      <div className="navbar">
        <div className="res_menu">
          <Button
            onClick={handleClick5}
            aria-label="Open Menu" // Add an aria-label
          >
            <MenuIcon />
          </Button>
        </div>
        <div className={`nav_sub ${anchorEl5 ? "showdiv" : ""}`}>
          <ul className="Nav_ul">
            <li
              onClick={handleClose5}
              className={pathname && pathname == "/" ? "active" : ""}
            >
              <Link href="/" onClick={() => router.push("/")}>
                Home
              </Link>
            </li>

            <li
              onClick={handleClose5}
              className={
                pathname && pathname == "/tarot-astrology-certification"
                  ? "active"
                  : ""
              }
            >
              <Link
                href="/tarot-astrology-certification"
                onClick={() => router.push("/tarot-astrology-certification")}
              >
                Divination Certification
              </Link>
            </li>

            {/* <li className={`nav_menu_items_drop_main  ${pathname && (pathname == "/tarot-astrology-certification") ? "active" : ""}`}
            >
              <span className="MuiTypography-root MuiTypography-inherit MuiLink-root MuiLink-underlineAlways css-z4r21k flx_center">
                Divination service <KeyboardArrowDownIcon />
              </span>

              <ul className={`nav_menu_items_drop ${anchorEl5 ? "showdrop" : ""}`}>
                <li onClick={handleClose5} className={pathname && pathname == "/tarot-astrology-certification" ? "active" : ""}>
                  <Link href="/tarot-astrology-certification" onClick={() => router.push("/tarot-astrology-certification")}>Tarot/Astrology Certification</Link>
                </li>

                <li onClick={handleClose5}>
                  <span onClick={handleNewwOpen}>Get a reading</span>
                </li>
              </ul>
            </li> */}

            <li
              className={`nav_menu_items_drop_main  ${
                pathname &&
                (pathname == "/central-doctrine" ||
                  pathname == "/divine-arcana-tarots" ||
                  pathname == "/rota-the-wheel" ||
                  pathname == "/tarot-typology" ||
                  pathname == "/raja-kundalini" ||
                  pathname == "/ritual-praxis" ||
                  pathname == "/pentagram-ritual" ||
                  pathname == "/ochema-ritual" ||
                  pathname == "/deities" ||
                  pathname == "/influences" ||
                  pathname == "/calendar-of-events" ||
                  pathname == "/calendar-of-events-newly" ||
                  pathname == "/layman-explanation" ||
                  pathname == "/suggested-order" ||
                  pathname == "/planetary-meditation" ||
                  pathname == "/diet" ||
                  pathname == "/ontology-of-being" ||
                  pathname == "/iamblichean-vs-astrological-theurgy" ||
                  pathname == "/divine-manifestation" ||
                  pathname == "/the-persona" ||
                  pathname == "/astrology-and-theurgy")
                  ? "active"
                  : ""
              }`}
            >
              <span className="MuiTypography-root MuiTypography-inherit MuiLink-root MuiLink-underlineAlways css-z4r21k flx_center">
                {" "}
                Mystery School <KeyboardArrowDownIcon />
              </span>

              <ul
                className={`nav_menu_items_drop ${anchorEl5 ? "showdrop" : ""}`}
              >
                <li
                  onClick={handleClose5}
                  className={
                    pathname && pathname == "/central-doctrine" ? "active" : ""
                  }
                >
                  <Link
                    href="/central-doctrine"
                    onClick={() => router.push("/central-doctrine")}
                  >
                    Central Doctrine
                  </Link>
                </li>

                <li
                  onClick={handleClose5}
                  className={
                    pathname && pathname == "/ritual-praxis-and-instructions" ? "active" : ""
                  }
                >
                  <Link
                    href="/ritual-praxis-and-instructions"
                    onClick={() => router.push("/ritual-praxis-and-instructions")}
                  >
                    Ritual Praxis and Instructions
                  </Link>
                </li>

                <li
                  onClick={handleClose5}
                  // className={
                  //   pathname && pathname == "/inner-mysteries-and-astrology"
                  //     ? "active"
                  //     : ""
                  // }
                >
                  <span onClick={() => handleNewOpen()}>
                    Mystery School Application
                  </span>
                </li>
                <li
                  onClick={handleClose5}
                  className={
                    pathname && pathname == "/layman-explanation"
                      ? "active"
                      : ""
                  }
                >
                  <Link
                    href="/layman-explanation"
                    onClick={() => router.push("/layman-explanation")}
                  >
                    Layman Explanation
                  </Link>
                </li>

                <li
                  onClick={handleClose5}
                  className={
                    pathname && pathname == "/divine-arcana-tarots"
                      ? "active"
                      : ""
                  }
                >
                  <Link
                    href="/divine-arcana-tarots"
                    onClick={() => router.push("/divine-arcana-tarots")}
                  >
                    Divine Arcana Tarot
                  </Link>
                </li>

                <li
                  onClick={handleClose5}
                  className={
                    pathname && pathname == "/rota-the-wheel" ? "active" : ""
                  }
                >
                  <Link
                    href="/rota-the-wheel"
                    onClick={() => router.push("/rota-the-wheel")}
                  >
                    Rota The Wheel
                  </Link>
                </li>

                <li
                  onClick={handleClose5}
                  className={
                    pathname && pathname == "/astrology-and-theurgy"
                      ? "active"
                      : ""
                  }
                >
                  {/* <span onClick={() => handleNewOpen()}>
                     Astrology and Theurgy
                  </span> */}
                  <Link
                    href="/astrology-and-theurgy"
                    onClick={() => router.push("/astrology-and-theurgy")}
                  >
                    Astrology and Theurgy
                  </Link>
                </li>
                <li
                  // onClick={handleNewOpen}
                  className={
                    pathname &&
                    pathname == "/iamblichean-vs-astrological-theurgy"
                      ? "active"
                      : ""
                  }
                >
                  <Link href="/iamblichean-vs-astrological-theurgy">
                    Iamblichean vs. Astrological Theurgy
                  </Link>
                </li>
                <li
                  onClick={handleClose5}
                  className={
                    pathname && pathname == "/suggested-order" ? "active" : ""
                  }
                >
                  {/* <span onClick={() => handleNewOpen()}>
                    Suggested Order of Practice
                  </span> */}
                  <Link
                    href="/suggested-order"
                    onClick={() => router.push("/suggested-order")}
                  >
                    Suggested Order of Practice
                  </Link>
                </li>
                <li
                  onClick={handleClose5}
                  className={
                    pathname && pathname == "/raja-kundalini" ? "active" : ""
                  }
                >
                  <Link
                    href="/raja-kundalini"
                    onClick={() => router.push("/raja-kundalini")}
                  >
                    Raja Kundalini
                  </Link>
                </li>
                <li
                  onClick={handleClose5}
                  className={
                    pathname && pathname == "/planetary-meditation"
                      ? "active"
                      : ""
                  }
                >
                  {/* <span onClick={() => handleNewOpen()}>
                    Planetary Meditation
                  </span> */}
                  <Link
                    href="/planetary-meditation"
                    onClick={() => router.push("/planetary-meditation")}
                  >
                    Planetary Meditation
                  </Link>
                </li>

                <li
                  onClick={handleClose5}
                  className={
                    pathname && pathname == "/the-persona" ? "active" : ""
                  }
                >
                  {/* <span onClick={() => handleNewOpen()}>
                    Planetary Meditation
                  </span> */}
                  <Link
                    href="/the-persona"
                    onClick={() => router.push("/the-persona")}
                  >
                    Persona Mask of the Infinite
                  </Link>
                </li>
                <li
                  onClick={handleClose5}
                  className={
                    pathname && pathname == "/divine-manifestation"
                      ? "active"
                      : ""
                  }
                >
                  {/* <span onClick={() => handleNewOpen()}>
                    Planetary Meditation
                  </span> */}
                  <Link
                    href="/divine-manifestation"
                    onClick={() => router.push("/divine-manifestation")}
                  >
                    Divine Manifestation
                  </Link>
                </li>
                <li
                  onClick={handleClose5}
                  className={
                    pathname && pathname == "/ritual-praxis" ? "active" : ""
                  }
                >
                  <Link
                    href="/ritual-praxis"
                    onClick={() => router.push("/ritual-praxis")}
                  >
                    Ritual of the Pentagram
                  </Link>
                </li>
                {/* <li
                  onClick={handleClose5}
                  className={
                    pathname && pathname == "/pentagram-ritual" ? "active" : ""
                  }
                >
                  <Link href="/pentagram-ritual" onClick={() => router.push("/pentagram-ritual")}>
                    Pentagram Ritual
                  </Link>
                </li>
                <li
                  onClick={handleClose5}
                  className={
                    pathname && pathname == "/ochema-ritual" ? "active" : ""
                  }
                >
                  <Link href="/ochema-ritual" onClick={() => router.push("/ochema-ritual")}>
                    Ochêma Ritual
                  </Link>
                </li> */}
                <li
                  onClick={handleClose5}
                  className={pathname && pathname == "/diet" ? "active" : ""}
                >
                  <Link href="/diet" onClick={() => router.push("/diet")}>
                    Diet and Physical Discipline
                  </Link>
                </li>

                <li
                  onClick={handleClose5}
                  className={
                    pathname && pathname == "/ontology-of-being" ? "active" : ""
                  }
                >
                  {/* <span onClick={() => handleNewOpen()}>
                    Ontology of Being
                  </span> */}
                  <Link
                    href="/ontology-of-being"
                    // onClick={() => handleNewOpen()}
                  >
                    Ontology of Being
                  </Link>
                </li>

                <li
                  onClick={handleClose5}
                  className={pathname && pathname == "/deities" ? "active" : ""}
                >
                  <Link href="/deities" onClick={(e) => deitiesredirect(e)}>
                    Deities
                  </Link>
                </li>

                <li
                  onClick={handleClose5}
                  className={
                    pathname && pathname == "/influences" ? "active" : ""
                  }
                >
                  <Link
                    href="/influences"
                    onClick={() => router.push("/influences")}
                  >
                    Influences
                  </Link>
                </li>

                {/* <li
                  onClick={handleClose5}
                >
                  <span onClick={() => studychapfunc()}>
                    Study Chapters
                  </span>
                </li> */}

                <li
                  onClick={handleClose5}
                  className={
                    pathname && pathname == "/tarot-typology" ? "active" : ""
                  }
                >
                  <Link
                    href="/tarot-typology"
                    onClick={() => router.push("/tarot-typology")}
                  >
                    Tarot Typology
                  </Link>
                </li>
                <li
                  onClick={handleClose5}
                  className={
                    pathname && pathname == "/calendar-of-events"
                      ? "active"
                      : ""
                  }
                >
                  <span onClick={() => calenderredirect()}>
                    Calendar Of Events
                  </span>
                </li>
                {/* <li
                  onClick={handleClose5}
                  className={
                    pathname && pathname == "/calendar-of-events-newly" ? "active" : ""
                  }
                >
                  <span onClick={() => calenderredirectNewly()}>
                    Calendar Of Events New
                  </span>
                </li> */}
                {/* <li onClick={handleClose5}>
                  <span onClick={() => memberfunc()}>Membership</span>
                </li> */}
              </ul>
            </li>

            {/* <li
              onClick={handleClose5}
              title="Learn more about our spiritual tradition"
              className={
                pathname && pathname == "/perennial-mandalism" ? "active" : ""
              }
            >
              <Link
                href="/perennial-mandalism"
                title="Learn more about our spiritual tradition"
                onClick={() => router.push("/perennial-mandalism")}
              >
                Perennial Mandalism
              </Link>
            </li> */}

            <li
              className={`nav_menu_items_drop_main  ${
                pathname &&
                (pathname == "/perennial-mandalism" ||
                  pathname == "/astrology-community" ||
                  pathname == "/baptism-by-fire-and-water")
                  ? "active"
                  : ""
              }`}
            >
              <span className="MuiTypography-root MuiTypography-inherit MuiLink-root MuiLink-underlineAlways css-z4r21k flx_center">
                {" "}
                Perennial Mandalism <KeyboardArrowDownIcon />
              </span>

              <ul
                className={`nav_menu_items_drop ${anchorEl5 ? "showdrop" : ""}`}
              >
                <li
                  // onClick={handleNewOpen}
                  className={
                    pathname && pathname == "/astrology-community"
                      ? "active"
                      : ""
                  }
                >
                  {/* <span onClick={() => handleNewOpen()}>
                    Astrology Community
                  </span> */}
                  <Link
                    href="/astrology-community"
                    // onClick={() => handleNewOpen()}
                  >
                    Astrology Community
                  </Link>
                </li>
                <li
                  onClick={handleClose5}
                  className={
                    pathname && pathname == "/perennial-mandalism"
                      ? "active"
                      : ""
                  }
                >
                  <Link
                    href="/perennial-mandalism"
                    onClick={() => router.push("/perennial-mandalism")}
                  >
                    Five Fold Creed
                  </Link>
                </li>
                <li
                  onClick={handleClose5}
                  // onClick={handleNewOpen}
                  className={
                    pathname && pathname == "/baptism-by-fire-and-water"
                      ? "active"
                      : ""
                  }
                >
                  {/* <span onClick={() => handleNewOpen()}>
                    Baptism by Fire and Water
                  </span> */}
                  <Link
                    href="/baptism-by-fire-and-water"
                    onClick={() => router.push("/baptism-by-fire-and-water")}
                  >
                    Baptism by Fire and Water
                  </Link>
                </li>
              </ul>
            </li>

            {/* <li
              className={`nav_menu_items_drop_main  ${pathname &&
                (
                  pathname == "/aleister-crowley" ||
                  pathname == "/alexandria" ||
                  pathname == "/chaldean-mysteries" ||
                  pathname == "/joseph-smith"
                )
                ? "active"
                : ""
                }`}
            >
              <span className="MuiTypography-root MuiTypography-inherit MuiLink-root MuiLink-underlineAlways css-z4r21k flx_center">
                {" "}
                Essays <KeyboardArrowDownIcon />
              </span>
              <ul
                className={`nav_menu_items_drop ${anchorEl5 ? "showdrop" : ""}`}
              >


                <li
                  onClick={handleClose5}
                  className={
                    pathname && pathname == "/chaldean-mysteries"
                      ? "active"
                      : ""
                  }
                >
                  <Link href="/chaldean-mysteries" onClick={() => router.push("/chaldean-mysteries")}>
                    Chaldean Mysteries
                  </Link>
                </li>
                <li
                  onClick={handleClose5}
                  className={
                    pathname && pathname == "/alexandria" ? "active" : ""
                  }
                >
                  <Link href="/alexandria" onClick={() => router.push("/alexandria")}>
                    Alexandria
                  </Link>
                </li>
                <li
                  onClick={handleClose5}
                  className={
                    pathname && pathname == "/aleister-crowley" ? "active" : ""
                  }
                >
                  <Link href="/aleister-crowley" onClick={() => router.push("/aleister-crowley")}>
                    Aleister Crowley
                  </Link>
                </li>
                <li
                  onClick={handleClose5}
                  className={
                    pathname && pathname == "/joseph-smith" ? "active" : ""
                  }
                >
                  <Link href="/joseph-smith" onClick={() => router.push("/joseph-smith")}>
                    Joseph Smith
                  </Link>
                </li>


              </ul>
            </li> */}

            <li
              onClick={handleClose5}
              className={`nav_menu_items_drop_main  ${
                pathname && pathname == "/shop" ? "active" : ""
              }`}
            >
              <Link href="/shop" onClick={() => router.push("/shop")}>
                Shop
              </Link>
            </li>

            <li
              onClick={handleClose5}
              className={
                pathname && pathname == "/curl-jung-debates" ? "active" : ""
              }
            >
              <Link
                href="/curl-jung-debates"
                onClick={() => router.push("/curl-jung-debates")}
              >
                Jung Debates
              </Link>
            </li>

            <li
              className={`nav_menu_items_drop_main  ${
                pathname &&
                (pathname == "/bio-of-eddie-paredes" ||
                  pathname == "/timothy-desmond" ||
                  pathname == "/witchy-tabby")
                  ? "active"
                  : ""
              }`}
            >
              <span className="MuiTypography-root MuiTypography-inherit MuiLink-root MuiLink-underlineAlways css-z4r21k flx_center">
                {" "}
                Our Leadership <KeyboardArrowDownIcon />
              </span>

              <ul
                className={`nav_menu_items_drop ${anchorEl5 ? "showdrop" : ""}`}
              >
                <li
                  onClick={handleClose5}
                  className={
                    pathname && pathname == "/bio-of-eddie-paredes"
                      ? "active"
                      : ""
                  }
                >
                  <Link
                    href="/bio-of-eddie-paredes"
                    onClick={() => router.push("/bio-of-eddie-paredes")}
                  >
                    Head Master - Eddie Paredes
                  </Link>
                </li>

                <li
                  onClick={handleClose5}
                  className={
                    pathname && pathname == "/timothy-desmond" ? "active" : ""
                  }
                >
                  <Link
                    href="/timothy-desmond"
                    onClick={() => router.push("/timothy-desmond")}
                  >
                    Timothy Desmond
                  </Link>
                </li>
                <li
                  onClick={handleClose5}
                  className={
                    pathname && pathname == "/witchy-tabby" ? "active" : ""
                  }
                >
                  <Link
                    href="/witchy-tabby"
                    onClick={() => router.push("/witchy-tabby")}
                  >
                    Tabatha Adams
                  </Link>
                </li>
              </ul>
            </li>

            <li
              onClick={handleClose5}
              className={pathname && pathname == "/contact-us" ? "active" : ""}
            >
              <Link
                href="/contact-us"
                onClick={() => router.push("/contact-us")}
              >
                Contact
              </Link>
            </li>

            {/* <li
              className={`nav_menu_items_drop_main  ${pathname && (pathname == "/our-faculty" || pathname == "/contact-us") ? "active" : ""
                }`}
            >
              <span className="MuiTypography-root MuiTypography-inherit MuiLink-root MuiLink-underlineAlways css-z4r21k flx_center">
                {" "}
                About <KeyboardArrowDownIcon />
              </span>

              <ul className={`nav_menu_items_drop ${anchorEl5 ? "showdrop" : ""}`}>

                <li
                  onClick={handleClose5}
                  className={
                    pathname && pathname == "/our-faculty" ? "active" : ""
                  }
                >
                  <Link href="/our-faculty" onClick={() => router.push("/our-faculty")}>
                    Our Faculty
                  </Link>
                </li>

                <li
                  onClick={handleClose5}
                  className={
                    pathname && pathname == "/contact-us" ? "active" : ""
                  }
                >
                  <Link href="/contact-us" onClick={() => router.push("/contact-us")}>
                    Contact Us
                  </Link>
                </li>

              </ul>
            </li> */}

            {/* <li onClick={handleClose5} className={pathname && pathname == "/psi-studies" ? "active" : ""}
            >
              <Link href="/psi-studies" onClick={() => router.push("/psi-studies")}>
                PSI Studies +
              </Link>
            </li> */}

            <li onClick={handleClose5}>
              {/* <Link href="https://divineinfinitebeing.influxiq.com/"> */}
              <Link href={process.env.NEXT_PUBLIC_BACKOFFICE_URL}>
                {" "}
                School Login{" "}
              </Link>
            </li>
          </ul>
        </div>
        <FloatingCartButton count={cartCount} hidden={hideCartOnThisRoute} />
        {/* {router.pathname != "/shop/cart" &&
          router.pathname != "/payment-success-page" &&
          router.pathname != "/login" &&
          router.pathname != "/subscription" &&
          cartCount > 0 && (
            <div className="cart_sec" onClick={() => router.push("/shop/cart")}>
              <Link href="/shop/cart">
                <Badge badgeContent={cartCount} color="primary">
                  <ShoppingCartIcon />
                </Badge>
              </Link>
            </div>
          )} */}
      </div>

      {showOtherBlocks && (
        <>
          <Modal
            open={newOpen}
            onClose={handleNewClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="banner_modal_main"
          >
            <Box className="banner_modal_box_new">
              <Typography
                id="modal-modal-description"
                component="div"
                sx={{ mt: 2 }}
                className="modal_banner_new"
              >
                <div className="sub_modal_banner">
                  <span className="close_btn" onClick={handleNewClose}>
                    <CloseIcon />
                  </span>
                  <img
                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/assets/images/logobanner.webp"
                    alt="bannerLogo"
                  />
                  <p className="modal_commingsoon">Coming soon</p>
                </div>
              </Typography>
            </Box>
          </Modal>

          <Modal
            open={calendermodalopen}
            onClose={handlecalendermodalopen}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="banner_modal_main"
          >
            <Box className="banner_modal_box_new">
              <Typography
                id="modal-modal-description"
                component="div"
                sx={{ mt: 2 }}
                className="modal_banner_new"
              >
                <div className="sub_modal_banner">
                  <span className="close_btn" onClick={handlecalendermodalopen}>
                    <CloseIcon />
                  </span>
                  <img
                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/assets/images/logobanner.webp"
                    alt="bannerLogo"
                  />
                  <p className="modal_commingsoon">
                    We will be publishing our calendar of events on January 1st,
                    2025. To stay informed please enter your email address
                  </p>
                </div>
              </Typography>
            </Box>
          </Modal>

          {newwOpen && (
            <FindDivineModal newwOpen={newwOpen} setNewwOpen={setNewwOpen} />
          )}

          {membershipOpen ? (
            <MembershipModal
              membershipOpen={membershipOpen}
              setMembershipOpen={setMembershipOpen}
            />
          ) : (
            ""
          )}
          {studychapOpen && (
            <StudyChapterModal
              studychapOpen={studychapOpen}
              setStudychapOpen={setStudychapOpen}
            />
          )}
        </>
      )}
    </>
  );
};

export default Navbar;
